import { render, staticRenderFns } from "./RecUser.vue?vue&type=template&id=70b9586c&"
import script from "./RecUser.vue?vue&type=script&lang=js&"
export * from "./RecUser.vue?vue&type=script&lang=js&"
import style0 from "./RecUser.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports